export default __webpack_public_path__ + "static/media/payment-method-icon.f824983a.svg";